/* Joe Aventure — injection des tuiles de confiance dans la grille de collection.
   Compatible avec le rendu JS de l'app Globo Filter (la grille est reconstruite côté client).
   Insère les tuiles (templates #joe-trust-templates) après la N-ième carte produit.

   Hauteur : on mesure `.grid-product__content` de la carte voisine (= sa hauteur VISIBLE,
   image + méta) et non la cellule, qui est étirée à la hauteur de la rangée. La tuile fait
   ainsi exactement la même hauteur que les cartes. Mesure unique via rAF (pas de
   ResizeObserver -> aucune boucle de rétroaction). Se ré-exécute quand Globo redessine. */
(function () {
  function init() {
    var section = document.getElementById('CollectionSection');
    var tplWrap = document.getElementById('joe-trust-templates');
    if (!section || !tplWrap) return;
    var defs = [].map.call(tplWrap.querySelectorAll('template'), function (t) {
      return { pos: parseInt(t.getAttribute('data-pos'), 10), html: t.innerHTML };
    });
    if (!defs.length) return;

    var observer, scheduled = false;
    var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };

    function inject() {
      var first = section.querySelector('.grid-product:not(.joe-trust-cell)');
      if (!first) return;
      var grid = first.parentNode;
      [].forEach.call(grid.querySelectorAll('.joe-trust-cell'), function (el) {
        el.parentNode.removeChild(el);
      });
      var cells = grid.querySelectorAll(':scope > .grid-product:not(.joe-trust-cell)');
      var pairs = [];
      defs.forEach(function (d) {
        if (cells.length >= d.pos) {
          var ref = cells[d.pos - 1];
          var tmp = document.createElement('div');
          tmp.innerHTML = d.html;
          var cell = tmp.querySelector('.joe-trust-cell');
          if (cell) {
            ref.parentNode.insertBefore(cell, ref.nextSibling);
            var tile = cell.querySelector('.joe-trust-tile') || cell;
            tile.style.height = '';
            pairs.push({ tile: tile, ref: ref });
          }
        }
      });
      raf(function () {
        pairs.forEach(function (p) {
          // hauteur visible de la carte voisine (pas la cellule étirée)
          var box = p.ref.querySelector('.grid-product__content') || p.ref;
          var h = box.offsetHeight;
          if (h > 80 && h < 1000) { p.tile.style.height = h + 'px'; }
        });
      });
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        if (observer) { observer.disconnect(); }
        try { inject(); } catch (e) {}
        if (observer) { observer.observe(section, { childList: true, subtree: true }); }
      }, 200);
    }

    observer = new MutationObserver(schedule);
    observer.observe(section, { childList: true, subtree: true });
    schedule();
    window.addEventListener('load', schedule);
    window.addEventListener('resize', schedule);
    setTimeout(schedule, 800);
    setTimeout(schedule, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
